import React from 'react'

// NOTE: this was a legacy "factory component" — (props) => ({ render() {} }).
// React calls the factory ONCE at mount, so callbacks captured in the factory
// closure (onChangeText/prop) were frozen from the first render: the dropdown
// DISPLAYED the current value but onChange wrote through the stale closure,
// silently updating whichever object was selected when the panel mounted.
// Rewritten as a plain function component so props are always current.
export default function SelectObjComponent({ header, value, onChangeText, prop, options, viewOnly }) {
    let v = '';
    if (typeof value === 'object' && !Array.isArray(value) && value !== null) {
        v = value.label;
    }
    else {
        if (typeof options === 'object' && Array.isArray(options)) {
            const found = options.find(i => (typeof i === 'object' ? i.value : i) == value);
            if (found) v = typeof found === 'object' ? found.label : found;
            else v = value;
        }
        else v = value;
    }

    return (<div className="">
        <div>{header}</div>
        {viewOnly && <div>{v}</div>}
        {!viewOnly && <select value={value} onChange={(e) => { onChangeText(prop, e.target.value) }} className="form-control">
            <option>{'Please select'}</option>
            {options.map(i => <option key={typeof i === 'object' ? prop + '_' + i.label : prop + '_' + i} value={typeof i === 'object' ? i.value : i} >{typeof i === 'object' ? i.label : i}</option>)}
        </select>}
    </div>);
}
